import React from 'react';
import { Box } from '@mui/material';

const RainbowBackground = ({ colors, renderWidth = 210 }) => {
  const height = 297; // A4 height in mm
  
  // Rainbow colors exactly as shown in the screenshot
  const rainbowColors = [
    '#FF6B6B', // Red/Orange
    '#FFB347', // Orange
    '#FFEB3B', // Yellow
    '#4CAF50', // Green
    '#2196F3', // Blue
    '#9C27B0', // Purple
  ];

  // If no colors provided, don't render
  if (!colors) {
    console.warn('RainbowBackground: No colors received. Rendering nothing.');
    return null;
  }

  const lineWidth = 2; // Very thin lines
  const lineSpacing = 3; // Space between lines
  const cornerSize = 60; // Size of the corner area

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <svg 
        width="100%" 
        height="100%" 
        viewBox={`0 0 ${renderWidth} ${height}`}
        preserveAspectRatio="xMidYMid slice"
        style={{ display: 'block' }}
      >
        <defs>
          {/* Clipping path for top-right corner */}
          <clipPath id="topRightCorner">
            <polygon points={`${renderWidth - cornerSize},0 ${renderWidth},0 ${renderWidth},${cornerSize}`} />
          </clipPath>
          
          {/* Clipping path for bottom-left corner */}
          <clipPath id="bottomLeftCorner">
            <polygon points={`0,${height - cornerSize} 0,${height} ${cornerSize},${height}`} />
          </clipPath>
        </defs>
        
        {/* Top-right diagonal rainbow lines */}
        <g clipPath="url(#topRightCorner)">
          {rainbowColors.map((color, index) => (
            <line
              key={`top-${index}`}
              x1={renderWidth - cornerSize + (index * lineSpacing)}
              y1={0}
              x2={renderWidth}
              y2={cornerSize - (index * lineSpacing)}
              stroke={color}
              strokeWidth={lineWidth}
              opacity="0.8"
            />
          ))}
        </g>
        
        {/* Bottom-left vertical rainbow lines */}
        <g clipPath="url(#bottomLeftCorner)">
          {rainbowColors.map((color, index) => (
            <line
              key={`bottom-${index}`}
              x1={index * lineSpacing}
              y1={height - cornerSize}
              x2={index * lineSpacing}
              y2={height}
              stroke={color}
              strokeWidth={lineWidth}
              opacity="0.8"
            />
          ))}
        </g>
      </svg>
    </Box>
  );
};

export default RainbowBackground; 